import { useEffect, useState } from 'react';
import { addToFavourites, removeFromFavourites } from '../../../../../helpers/favouritesHandler';
import { MiniEntry, MiniFavouritesData } from '../../../../../types';
import initMiniFavourites, { emptyFavouritesData } from '../../../../global/header/miniFavourites';

export type FavouritesToggler = (isFavourite: boolean, productCode: string) => void;
interface UseFavouritesHandlerReturnValue {
  addedToFavourites: MiniEntry | null;
  setAddedToFavourites: React.Dispatch<React.SetStateAction<MiniEntry | null>>;
  favouritesData: MiniFavouritesData;
  favouritesToggler: FavouritesToggler;
}

function useFavouritesHandler(): UseFavouritesHandlerReturnValue {
  const [addedToFavourites, setAddedToFavourites] = useState<MiniEntry | null>(null);
  const [favouritesData, setFavouritesData] = useState<MiniFavouritesData>(emptyFavouritesData);
  const { updateMiniFavouritesGlobalState, updateMiniFavouritesMarkup, fetchInitialMiniFavourites } =
    initMiniFavourites();

  function favouritesToggler(isFavourite: boolean, productCode: string): void {
    if (
      productCode &&
      window.bbGlobal.miniFavouritesData.isInitialDataFetched &&
      window.bbGlobal.miniFavouritesData.isDataFetching === false
    ) {
      const favouritesProcess = isFavourite ? removeFromFavourites : addToFavourites;
      window.bbGlobal.miniFavouritesData.isDataFetching = true;
      favouritesProcess(productCode)
        .then(({ entry, entries, miniFavouritesDisplayLimit }: MiniFavouritesData & { entry?: MiniEntry }) => {
          updateMiniFavouritesGlobalState({ entries, miniFavouritesDisplayLimit });
          updateMiniFavouritesMarkup({ entries, miniFavouritesDisplayLimit });
          if (!isFavourite && entry) {
            setAddedToFavourites(entry);
            setFavouritesData({ entries, miniFavouritesDisplayLimit });
          } else {
            setAddedToFavourites(null);
            setFavouritesData({ entries, miniFavouritesDisplayLimit });
          }
        })
        .catch(() => {
          console.error('Error in favourites');
          setAddedToFavourites(null);
          setFavouritesData(emptyFavouritesData);
        })
        .finally(() => {
          window.bbGlobal.miniFavouritesData.isDataFetching = false;
        });
    } else {
      console.error('Error in favourites');
    }
  }

  useEffect(() => {
    fetchInitialMiniFavourites().then((res) => {
      setFavouritesData(res);
    });
  }, []);

  return {
    addedToFavourites,
    setAddedToFavourites,
    favouritesData,
    favouritesToggler
  };
}

export default useFavouritesHandler;
